import loadable from '@loadable/component';

export const NewbuildingBrokerCallbackWidgetAdapterLoadable = loadable(
  () =>
    import('./NewbuildingBrokerCallbackWidgetAdapter').catch(
      /* istanbul ignore next */ () => ({ NewbuildingBrokerCallbackWidgetAdapter: () => null }),
    ),
  {
    resolveComponent: ({ NewbuildingBrokerCallbackWidgetAdapter }) => NewbuildingBrokerCallbackWidgetAdapter,
    ssr: false,
  },
);
